import GlobalHeader from '@/mikan/pc/components/organisms/GlobalHeader.vue';
import GlobalFooter from '@/mikan/pc/components/organisms/GlobalFooter.vue';
import RestaurantHeader from '@/mikan/pc/components/organisms/RestaurantHeader.vue';
import RestaurantNavigation from '@/mikan/pc/components/organisms/RestaurantNavigation.vue';
import RestaurantIndexSidebarAd from '@/mikan/pc/components/organisms/RestaurantIndex/RestaurantIndexSidebarAd.vue';
import AdminToolBar from '@/mikan/pc/components/organisms/AdminToolBar.vue';

export default {
  '#js-global-header': {
    components: {
      GlobalHeader,
    },
  },
  '#js-global-footer': {
    components: {
      GlobalFooter,
    },
  },
  '#js-restaurant-header': {
    components: {
      RestaurantHeader,
    },
  },
  '#js-restaurant-navigation': {
    components: {
      RestaurantNavigation,
    },
  },
  '#js-restaurant-ad': {
    components: {
      RestaurantIndexSidebarAd,
    },
  },
  '#js-admin-tool-bar': {
    components: {
      AdminToolBar,
    },
  },
};
